
<template>
  <div class="regist-dialog" v-if="false">
    <!-- <div class="big-image" style="height: 0"></div> -->
    <div class="mark"></div>
    <div :class="['dialog-content', !isNext ? 'small-image' : 'big-image']">
      <div class="dialog-left">
        <div class="dialog-left-title">
          <div>Create Your Free Account</div>
          <!-- <div>Get a 15-Day Free Trial!</div> -->
        </div>
        <el-carousel 
          :autoplay="false" 
          arrow="always"
          class="regist-carousel">
          <el-carousel-item v-for="(item, index) in waperList" :key="index">
            <div :class="'carousel' + index">
              <img :src="item.bg">
              <div class="carousel-tips">{{item.tip}}</div>
            </div>
          </el-carousel-item>
        </el-carousel>
        <div class="dialog-left-footer">
          <div>No Long-Term Commitment or Credit Card Required!</div>
          <div>Learn more about the COMMAND free trial program</div>
        </div>
      </div>
      <div style="position: relative" class="dialog-right">
        <svg-icon name="close" style="height: 20px; width: 20px" class="close" @click.native="close"></svg-icon>
        <div :class="['regist-form']">
          <div class="regist-logo">
            <svg-icon name="Logo"></svg-icon>
          </div>
          <template v-if="registStep == 1">
            <div class="regist-title">Register For Free</div>
            <div class="regist-tips1">Equip your fleet with the best-in-class tools to deliver freight more efficiently.</div>
            <div class="form-container">
              <el-form 
                :model="stepsForm"
                class="steps-form-container"
                ref="stepsForm">
                <el-form-item
                  prop="email"
                  :rules="[
                    {
                      required: true,
                      message: 'Email is required',
                      trigger: 'blur',
                    },
                    {
                      validator: validatorEmail,
                      trigger: 'blur',
                    },
                  ]"
                >
                  <common-input
                    maxlength="50"
                    label="Email"
                    ref="emailInput"
                    v-model="stepsForm.email"
                  ></common-input>
                </el-form-item>
              </el-form>
            </div>
            <div class="regist-btn">
              <commonButton :loading="submitLoading" type="primary" size="small" @click="submitForm(1)">REGISTER FOR FREE</commonButton>
            </div>
            <div class="regist-tips">
              By registering, you agree to our <a target="_blank" :href='PolicyLink' class="regis-tips-more">Privacy Policy </a> and <a  target="_blank" class="regis-tips-more" :href='TermsLink'>Terms and Conditions</a>
            </div>
            <div class="alreay-us">
              Already have an account? 
              <span class="signIn" @click="login"> Log in</span>
            </div>
          </template>
          <template v-if="registStep == 2">
            <div class="regist-title"><svg-icon name="registEmail" style="height: 16px; width: 16px; margin-right: 4px"></svg-icon>Check your Email</div>
            <div class="regist-remink">
              In order to activate your account, click the link we sent to 
              <br/> 
              <common-ellipsis-tooltip
                popper-class=''
                effect="dark"
                :content="stepsForm.email + '.'"
                placement="top"
              >                
              </common-ellipsis-tooltip>
               Make sure to check your spam folder.
            </div>
            <div class="regist-forget-tips">Didn't get the email?</div>
            <div class="regist-btn fix-btn">
              <commonButton type="primary" size="small" @click="changeRegistStep">RESEND OR EDIT YOUR EMAIL</commonButton>
            </div>
          </template>
          <template v-if="registStep == 3">
            <div class="regist-title">Don’t see the confirmation email?</div>
            <div class="regist-remink">
              We’ve sent it to 
              <common-ellipsis-tooltip
                popper-class=''
                effect="dark"
                :content="showEmail + '.'"
                placement="top"
              >                
              </common-ellipsis-tooltip> Try checking again in a minute, check your spam folder, or request another email here:
            </div>
            <div class="form-container">
              <el-form 
                :model="stepsForm"
                class="steps-form-container"
                ref="stepsForm">
                <el-form-item
                  prop="email"
                  :rules="[
                    {
                      required: true,
                      message: 'Email is required',
                      trigger: 'blur',
                    },
                    {
                      validator: validatorEmail,
                      trigger: 'blur',
                    },
                  ]"
                >
                  <common-input
                    maxlength="50"
                    label="Email"
                    ref="emailInput"
                    v-model="stepsForm.email"
                  ></common-input>
                </el-form-item>
              </el-form>
            </div>
            <div class="regist-btn">
              <commonButton  :loading="submitLoading" size="small" type="primary" @click="submitForm">RESEND EMAIL</commonButton>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { newSignUp } from "@/api/user";
import { emailRex } from '@/tools/basic-methods'
import { validatorRegular } from '@/utils/form-rules' 
// import appendToDom from "@/components-v3/mixins/append-to-dom"
import { mapGetters, mapActions } from 'vuex'
import { getStorage } from '@/utils/storage'

export default {
  name: 'registDialog',
  // mixins: [appendToDom()],
  props: {
    disaledJump: {
      type: Boolean,
      default: false
    },
    redirect: {
      type: String
    },
    source:{
      type: String
    }
  },
  data() {
    var validatorPhone = (rule, value, callback) => {
      if (!value) {
        callback()
        return
      }
      const regular = /^.{12}$/
      if (!regular.test(value)) {
        callback(new Error('Please enter a valid Telephone.'))
      } else {
        callback()
      }
    }
    return {
      showEmail: '',
      registStep: 1,
      isNoSpacingRule: /^\S+$/,
      validatorRegular: validatorRegular,
      valiphone: {
        validator: validatorPhone,
        trigger: "blur"
      },
      PolicyLink: `${process.env.VUE_APP_POLICY}`,
      TermsLink: `${process.env.VUE_APP_TERMS}`,
      // nextIsDisabled: true,
      isNext: false,
      submitIsDisabled: true,
      submitLoading: false,
      confirmPasswordFlag: false,
      submitSuccessFlag: false,
      emailFlag: false,
      stepsForm: {
        email: ''
      },
      inNext: false,
      icon: "\ue69c",
      waperList: [
        {
          bg: require('../images/swper1.png'),
          tip: "All-in-one transportation management system combined with North America’s most popular app for commercial drivers"
        },
        {
          bg: require('../images/swper2.png'),
          tip: "Easy-to-use dispatch system and truck navigation"
        },
        {
          bg: require('../images/swper3.png'),
          tip: "High-quality document capture and seamless paper management"
        },
        {
          bg: require('../images/swper4.png'),
          tip: "Stay connected with your drivers through messaging, voice, file sharing, and real-time location tracking"
        },
        
      ]
    }
  },
  created() {
    // this.stepsForm.email = this.$route.query.email || ''
    // console.log(this.registEmail, 'this.registEmail')
    // if (this.registEmail) {
    //   this.stepsForm.email = this.registEmail
    //   this.showEmail = this.stepsForm.email
    //   this.registStep = 2
    // }
    this.$root.$emit("globalMarketingTools", {
        isLogin: false,
        onClose: () => {
          this.$emit('close')
        },
      })
  },
  mounted() {
    // this.$refs.emailInput && this.$refs.emailInput.focus()
  },
  computed: {
    ...mapGetters('user', [
      'registEmail'
    ]),
    ...mapGetters('shareTracking', ['shareId']),
    nextIsDisabled() {
      let nextIsDisabled = false
      const regular = new RegExp(emailRex)
       if (
          this.stepsForm.email &&
          this.stepsForm.password &&
          this.stepsForm.confirmPassword &&
          this.stepsForm.password === this.stepsForm.confirmPassword &&
          regular.test(this.stepsForm.email) && 
          this.isNoSpacingRule.test(this.stepsForm.password)
        ) {
          nextIsDisabled = false;
        } else {
          nextIsDisabled = true;
        }
        return nextIsDisabled
    },
    isShareTrip() {
      return /^\/map(\/.*)?$/.test(this.$route.path) && this.shareId
    }
  },
  watch: {
    stepsForm: {
      handler: function (data) {
        // if (
        //     data.email &&
        //     data.password &&
        //     data.confirmPassword &&
        //     this.confirmPasswordFlag &&
        //     this.emailFlag
        // ) {
        //   this.nextIsDisabled = false;
        // } else {
        //   this.nextIsDisabled = true;
        // }
        if (data.phone && data.phone.length > 10) {
          data.phone = data.phone.slice(0, 10)
        }
        let companyName = ''
        let fullName = ''
        if (data.companyName) {
          companyName = data.companyName.trim()
        }
        if (data.fullName) {
          fullName = data.fullName.trim()
        }
        if (companyName && data.trucksNumber && fullName && data.phone && data.phone.length === 10) {
          this.submitIsDisabled = false;
        } else {
          this.submitIsDisabled = true;
        }
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
      ...mapActions('user', [
        'setRegistEmail'
      ]),
      changeRegistStep() {
        this.registStep = 3
      },
      delSpacing(obj, key) {
        if (obj[key]) {
          obj[key] = obj[key].trim()
        }
      },
      sliceNumber(value, key) {
        value = String(value);
        if (!/^\d{1,1000}$/.test(value)) {
          this.stepsForm[key] = null
          return
        }
        this.stepsForm[key] = value.replace(/[^\d.]/g,'')
      },
      changeTruckNumber(name) {
        let value = this.stepsForm[name]
        if (typeof value == 'number') {
          value = value.toString()
        }
        value = value.trim()
        if (!/^\d{1,1000}$/.test(value)) {
          this.stepsForm[name] = null
          return
        }
        if (value) {
          value = value.replace(/[^\d.]/g,'')
          this.stepsForm[name] = parseInt(value)
        }
      },
      close() {
        this.$emit('close')
      },
      login() {
        if (this.redirect) {
          window.location.href =  window.location.origin + '/login?redirect=' + this.redirect
        } else {
          window.location.href = window.location.origin + '/login'
        }
        // if(!this.redirect) {
        //   this.$router.push({
        //     path: `/login`
        //   })
        // } else {
        //   this.$router.push({
        //     path: `/login`,
        //     query: {
        //       redirect: this.redirect
        //     }
        //   })
        // }
      },
     validatorConfirmPassword(rule, value, callback) {
      if (value !== this.stepsForm.password) {
        this.confirmPasswordFlag = false;
        // this.nextIsDisabled = true;
        callback(new Error("The two passwords are inconsistent!"));
      } else {
        this.confirmPasswordFlag = true;
        // if (
        //   this.stepsForm.email &&
        //   this.stepsForm.password &&
        //   this.stepsForm.confirmPassword &&
        //   this.confirmPasswordFlag &&
        //   this.emailFlag
        // ) {
        //   this.nextIsDisabled = false;
        // } else {
        //   this.nextIsDisabled = true;
        // }
        callback();
      }
    },
    validatorEmail(rule, value, callback) {
      const regular = new RegExp(emailRex)
      if (!regular.test(value) && value && value.toString().length) {
        this.emailFlag = false;
        // this.nextIsDisabled = true;
        callback(new Error("Please enter a valid email address."));
      } else {
        this.emailFlag = true;
        // if (
        //   this.stepsForm.email &&
        //   this.stepsForm.password &&
        //   this.stepsForm.confirmPassword &&
        //   this.confirmPasswordFlag &&
        //   this.emailFlag
        // ) {
        //   this.nextIsDisabled = false;
        // } else {
        //   this.nextIsDisabled = true;
        // }
        callback();
      }
    },
    next() {
      if (!this.disaledJump) {
         this.$buriedPoints(10.14)
      }
      this.isNext = true;
      let itemErrorDom = document.querySelector(".el-form-item__error");
      let trialContainer = document.querySelector(".trial-container");
      trialContainer && (trialContainer.style.height = "815px")
      if (itemErrorDom) {
        itemErrorDom.style.display = "none";
      }
    },
    back() {
      this.isNext = false;
      let itemErrorDom = document.querySelector(".el-form-item__error");
      let trialContainer = document.querySelector(".trial-container");
      trialContainer && (trialContainer.style.height = "679px")
      if (itemErrorDom) {
        itemErrorDom.style.display = "none";
      }
    },
    submitForm(da) {
      if (this.isShareTrip) {
        this.$buriedPoints(21.2)
      }
      if (da) {
        this.$buriedPoints(18.5)
      }
      this.$refs.stepsForm.validate((res) => {
        if (res) {
          this.submitLoading = true;
          let tripUrl = ''
          let source = 'scan-doc' 
          if (this.isShareTrip) {
            tripUrl = window.location.origin + window.location.pathname + `?shareId=${this.shareId}`
            source = 'shareTrack'
            this.$buriedPoints(15.16)
          }
          const utm = getStorage('commandRegistSource') || 'Freemium'
          const marketingUtm = getStorage('commandRegistMarketingUtm') || {utm_source: 'Freemium'}

          const params = {
            email: this.stepsForm.email,
            tripUrl: tripUrl,
            source: source,
            utm: marketingUtm?.utm_source || utm,
            marketingUtm: {
              source: marketingUtm?.utm_source || "",
              content: marketingUtm?.utm_content || "",
              medium: marketingUtm?.utm_medium || "",
              campaign: marketingUtm?.utm_campaign || "",
              term: marketingUtm?.utm_term || ""
            }
          }
          newSignUp(params).then(
            (res) => {
              if (res.code == 200) {
                this.setRegistEmail(this.stepsForm.email)
                this.showEmail = this.stepsForm.email
                this.registStep = 2
                this.$buriedPoints(1.0, {Outcome: "Freemium", Source:  marketingUtm?.utm_source || utm})
              } else {
                this.$message.error({ message: res.message });
              }
              this.submitLoading = false;
            },
            () => {
              this.submitLoading = false;
              // this.$message.error({ message: error.message });
            }
          );
        }
      });
    },
  }
}
</script>
<style scoped lang="scss">
.regist-line{
  display: flex;
  align-items: center;
  span{
    width: 3px;
    height: 3px;
    border-radius: 50%;
    background: #b2b6c0;
    margin-right: 5px;

    &:first-child{
      margin-left: 6px;
    }
    &:last-child{
      margin-right: 7px;
    }
  }
  margin-right: 5px;
  
}
.regist-form-step{
  padding-left: 22px;
  color: #4066d4;
  font-family: OpenSans;
  font-size: 14px;
  line-height: 20px;
  font-weight: normal;
  white-space: nowrap;
  background: url("../images/icon-check.svg") no-repeat;
  background-size: 16px;
  background-position: left center;
}
.form-step-profile{
  background-image: url('../images/icon-setp-2.svg');
   color: #b2b6c0;
}
.step-profile{
  background-image: url('../images/icon-check2.svg');
  color: #4066d4;
}
.flex{
  display: flex;
  align-items: center;
  justify-content: center;
}
  .regist-dialog{ 
    /deep/ {
      .el-form-item__content{
        height: 36px;
        line-height: 36px;
      }
    }
  }
  .mark{
    position: fixed;
    top: 0;
    left: 0;
    height: 100vh;
    width: 100vw;
    background-color: rgba(0, 0, 0, 0.42);
    z-index: 104;
  } 

  .dialog-left-title{
      margin-top: 32px;
      margin-left: 50px;
      width: 414px;
      text-align: center;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      > div:first-child{
        font-family: 'Open Sans';
        font-style: normal;
        font-weight: 700;
        font-size: 20px;
        line-height: 28px;
        color: #000000;
      }
      // >div:last-child{
      //   margin-top: 4px;
      //   width: 202px;
      //   height: 32px;
      //   line-height: 32px;
      //   text-align: center;
      //   background: rgba(255, 255, 255, 0.1);
      //   color: #fff;
      //   font-family: OpenSans-Semibold;
      //   font-size: 12px;
      //   border-radius: 16px;
      // }
  }

  .regist-carousel{
    width: 450px;
    height: 294px;
    margin-top: 12px;
    margin-left: 32px;
    /deep/ {
      img{
        width: 338px;
        margin-left: 56px;
        // height: 208px;
      }
      .carousel0, .carousel1{
        img{
          width: 338px;
          height: 208px;
        }
      
      }
      .carousel2{
        img{
          width: 323px;
          height: 205px;
        }
        
      }
      .carousel3 img{
        width: 330px;
        height: 202px;
      }
      .el-carousel__arrow{
        display: block !important;
        width: 32px;
        // background: #fff;
        border-radius: 0;
        height: 32px;
        top: 88px;
        transform: translateY(0%);
        i{
          display: none;
        }
      }
      .el-carousel__arrow--left{
        left: 0;
        background: url('../images/Left.svg') no-repeat;
      }
      .el-carousel__arrow--right{
        right: 0;
        background: url('../images/Right.svg') no-repeat;
      }
      .el-carousel__container{
        height: 294px;
      }
      .el-carousel__indicators{
        height: 18px;
        bottom: 0px;
      }
      .carousel-tips{
        margin-top: 16px;
        margin-left: 0px;
        width: 450px;
        font-family: 'Open Sans';
        font-style: normal;
        font-weight: 600;
        font-size: 14px;
        line-height: 22px;
        color: #000000;
        text-align: center;
      }
      .el-carousel__indicator--horizontal{
        height: 10px;
        width: 10px;
        border-radius: 50%;
        padding: 0;
        background: rgba(76, 85, 108, 0.35);
        margin-right: 12px;
        .el-carousel__button{
          display: none;
        }
        &:last-child{
          margin-right: 0;
        }

        &.is-active{
          background: #4C556C;
        }
      }
    }
  }
  .dialog-left-footer{
    margin-top: 24px;
    margin-left: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    width: 450px;
    height: 62px;
    border-radius: 4px;
    background: #E9EDF3;
    text-align: center;
    >div:first-child{
      font-family: 'Open Sans';
      font-style: normal;
      font-weight: 600;
      color: #4C556C;
      font-size: 14px;
      line-height: 22px;
    }
    >div:last-child{
      font-family: 'Open Sans';
      font-style: normal;
      font-weight: 400;
      font-size: 12px;
      line-height: 16px;
      color: #4C556C;
    }
  }
  .small-image{
    height: 563px;
    // background: url('../images/free-trial-img.jpg') no-repeat;
  }
  .big-image{
    height: 698px;
    background: url("../images/free-trial.jpg") no-repeat;

    .dialog-left-title{
      margin-top: 116px;
    }    
  }
  
  .dialog-content{
    overflow: hidden;
    border-radius: 4px;
    width: 868px;
    height: 484px;
    position: fixed;
    z-index: 105;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
   
    background-size: 100% 100%;
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
  }
 
  .regist-form{
    padding-top: 64px;
    // margin-top: 81px;
    // margin-right: 74px;
    width: 100%;
    height: 100%;
    // box-shadow: 0 2px 16px 0 rgba(1, 4, 26, 0.1);
    // background: #fff;
    border-radius: 8px;
    overflow: hidden;
    // padding: 32px 32px 16px;

    & > div{
      padding-left: 32px;
      padding-right: 32px;
    }
  }
  .regist-step-form2{
    height: 595px;
    margin-top: 52px;
  }
   .form-container {
      width: 100%;
      margin-top: 32px;
      /deep/ {
        .el-form-item{
          margin-bottom: 0;
        }
        .label-input2 .el-input__inner{
          height: 32px !important;
        }
        .el-form-item__content{
          height: 32px;
          line-height: 32px;
        }
      }
    }
    .alreay-us{
      margin-top: 61px;
      font-family: 'Open Sans';
      font-style: normal;
      font-weight: 500;
      font-size: 12px;
      line-height: 16px;
      color: #141a42;
      text-align: center;

      .signIn{
        color: #4066d4;
        font-family: 'Open Sans';
        font-style: normal;
        font-weight: 500;
        font-size: 12px;
        line-height: 16px;
        cursor: pointer;
      }
    }
    div.regist-tips{
      margin-top: 11px;
      padding: 0px  32px;
      // background: #f9fafa;
      font-family: OpenSans;
      color: #72768e;
      font-size: 12px;
      // height: 56px;

    }
    .regis-tips-more{
      color: #4066d4;
      font-family: OpenSans;
      font-size: 12px;
      font-weight: normal;
      font-stretch: normal;
    }
    .close{
      cursor: pointer;
      position: absolute;
      right: 24px;
      top: 24px;
      height: 24px;
      width: 24px;
      z-index: 100;
      // background: url("../images/icon-24-close.svg") no-repeat;
    }
    .form-title{
      font-weight: bold;
      font-size: 16px;
      color: #1d2e42;
    }
    .regist-logo{
      display: flex;
      align-items: center;
      justify-content: center;
      /deep/ .svg-icon{
        width: 135px;
        height: 32px;
      }
    }
    .regist-title{
      margin-top: 24px;
      font-family: 'Open Sans';
      font-style: normal;
      font-weight: 700;
      font-size: 16px;
      line-height: 24px;
      text-align: center;
    }
    .regist-tips1{
      text-align: center;
      margin-top: 8px;
      font-family: 'Open Sans';
      font-style: normal;
      font-weight: 400;
      font-size: 12px;
      line-height: 16px;
      color: #4C556C;
    }
    .regist-btn{
      margin-top: 24px;
      /deep/ {
        .common-button{
          width: 100%;
        }
      }
    }
    div.regist-remink{
      font-family: 'Open Sans';
      font-style: normal;
      font-weight: 500;
      font-size: 14px;
      line-height: 22px;
      color: #4C556C;
      padding: 16px;
      background: #F5F7FA;
      border-radius: 4px;
      width: calc(100% - 64px);
      margin: 0 auto;
      margin-top: 32px;
      /deep/ span{
        font-family: 'Open Sans';
        font-style: normal;
        font-weight: 700;
        // max-width: 100%;
        // display: inline-block;
        // overflow: hidden;
        // text-overflow: ellipsis;
        // line-height: 19px;
        // vertical-align: middle;
      }
    }
    .regist-forget-tips{
      font-family: 'Open Sans';
      font-style: normal;
      font-weight: 500;
      font-size: 12px;
      line-height: 16px;
      text-align: center;
      color: #000;
      margin-top: 88px;
    }
    .dialog-left{
      background: #F5F7FA;
      width: 514px;
      height: 100%;
    }
    .dialog-right{
      background: #FFFFFF;
      width: calc(100% - 514px);
      height: 100%;
    }
    .fix-btn{
      position: absolute;
      margin-bottom: 0;
      bottom: 32px;
      left: 0;
      right: 0;
      z-index: 1;
    }
</style>
